export const FORCE_API_URL = ''; // Empty for relative path in production

// Add a version suffix to force fresh settings if structure changes
export const STORAGE_KEY = 'tourvisioApiSettings_v3';

export const DEFAULT_SETTINGS = {
    serviceAddress: FORCE_API_URL,
    agency: 'lumiweb',
    user: 'lumiwebus',
    password: '1',
    activeProviders: []
};
